import { createContext, type PropsWithChildren, type RefObject, useContext } from 'react';

type SidebarContextType = {
    sidebar: RefObject<HTMLDivElement | null> | null;
};

export const SidebarContext = createContext<SidebarContextType>({ sidebar: null } as SidebarContextType);

export const useSideBarContext = () => useContext(SidebarContext);

export const SidebarContextProvider = ({ sidebar, children }: PropsWithChildren<SidebarContextType>) => {
    return <SidebarContext value={{ sidebar }}>{children}</SidebarContext>;
};
